import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/Button";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import { StickersService } from "../../services/stickerServices";
import EmptyState from "../../components/EmptyState";

declare const bootstrap: any;

export default function StickersPartial() {
  const modalRef = useRef<HTMLDivElement>(null);

  const [modal, setModal] = useState<any>(null);
  const [stickers, setStickers] = useState<any>([]);

  const defaultValues = {
    sticker: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const showModal = (data?: any) => {
    modal.show();
  };

  const getStickers = async () => {
    const response = await StickersService.getAll();
    setStickers(response);
  };

  const submit = async (data: any) => {
    try {
      const form = new FormData();
      
      form.append("file", data.sticker[0]);
      await StickersService.save(form);

      await getStickers();

      reset(defaultValues);

      Alert.fire({
        title: "Sticker guardado",
        text: `Se guardo correctamente el sticker`,
      });

      modal.hide();
    } catch (error) {
      console.error(error);
      alert(error);
    }
  };

  const deleteSticker = async (id: string) => {
    try {
      const isOk = await Alert.danger({
        title: "Eliminar sticker",
        text: "¿Estás seguro de querer eliminar este sticker?",
        cancelText: "Cancelar",
        confirmText: "Eliminar",
      });

      if (isOk) {
        await StickersService.delete(id);
        await getStickers();
        Alert.close();
      }
    } catch (error) {
      console.error(error);
      Alert.setMessageError(error.message)
    }
  };

  useEffect(() => {
    if (modalRef.current) {
      const modalInstance = new bootstrap.Modal(modalRef.current, {});
      setModal(modalInstance);
    }
  }, [modalRef]);

  useEffect(() => {
    getStickers()
  }, []);

  return (
    <>
      <div className="d-flex align-items-center mb-3">
        <h5>Stickers</h5>
        <button
          type="button"
          className="btn btn-outline-primary ms-auto"
          onClick={() => showModal()}
        >
          nuevo sticker
        </button>
      </div>

      <div className="card m-b-16">
        <div className="card-body">
          {stickers.length === 0 && <EmptyState />}

          <div className="row  align-items-center">
            {stickers.map((sticker: any) => (
              <div key={sticker._id} className="col-2">
                <img src={sticker.url} alt="sticker" className="img-fluid"/>
                <div className="text-center">
                  <button type="button" className="btn btn-link  btn-icon text-danger btn-delete-stickers" onClick={() => deleteSticker(sticker._id)}>
                    <i className="bi bi-trash-fill"></i>
                    Eliminar
                  </button>
                </div>
                {/* <button type="button" className="btn btn-outline-primary btn-outline-trash  btn-icon ">
                    <i className="bi bi-trash-fill"></i>
                </button> */}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        ref={modalRef}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog" role="document">
          <form onSubmit={handleSubmit(submit)}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agregar sticker</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row ">
                  <div className="m-b-24">
                    <Input
                      label="Sticker *"
                      type="file"
                      errors={errors.sticker}
                      {...register("sticker", { required: true })}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-soft-primary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <Button
                  type="submit"
                  className="btn btn-primary btn-sm"
                  disabled={!isValid}
                  isLoading={isSubmitting}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
